export const KEY_CODE_ENTER = 13;
export const KEY_CODE_DELETE = 46;
export const KEY_CODE_BACKSPACE = 8;
